import { ThemeUICSSObject, ThemeUIStyleObject } from 'theme-ui';

export const defaultCardStyles: ThemeUIStyleObject = {
  transition: 'box-shadow 0.2s ease',
  overflow: 'hidden',
  boxShadow: 'sm',
  borderRadius: 'md',
  background: 'background',
};

export enum CARD_VARIANTS {
  primary = 'primary',
  article = 'article',
  highlight = 'highlight',
}

export const cards: Record<CARD_VARIANTS, ThemeUICSSObject> = {
  [CARD_VARIANTS.primary]: {
    ...defaultCardStyles,
  },
  [CARD_VARIANTS.article]: {
    ...defaultCardStyles,
    maxWidth: 288,
    ':hover': {
      boxShadow: 'md',
    },
  },
  [CARD_VARIANTS.highlight]: {
    ...defaultCardStyles,
  },
};
